import { BaseModel } from '@app/shared/models/base';
import { ActionListItem } from '@app/shared/components/action-list/action-list.component';

export interface Translatable {
    trans: string;
    trans2?: string;
}

export interface TranslationEntry extends Translatable {
    key: string;
}

export class TranslationEntryObject extends BaseModel implements TranslationEntry, ActionListItem {
    public trans: string;
    public key: string;

    get actionListDisplayName(): string {
        return this.trans;
    }

    constructor(json?: any) {
        super(json);
    }
}
